import React from "react";
import { Navigate } from "react-router-dom";

const PrivateRoute = ({ children }) => {
  // Check isLoggedIn directly from localStorage on render
  const isLoggedIn = localStorage.getItem("isLoggedIn") === "true";

  // Log for debugging
  console.log("PrivateRoute - isLoggedIn:", isLoggedIn);

  return isLoggedIn ? children : <Navigate to="/" />;
};

export default PrivateRoute;